import { AclPermissionsRole } from '@eventmanager/types';
import { getPermission, emptyPermissions } from '../selectors';
import { useAppSelector } from './redux';

export const usePermission = (role: AclPermissionsRole) => {
  const permission = useAppSelector(getPermission(role));
  return permission || emptyPermissions;
};
